module.exports = __webpack_public_path__ + "img/qrespi-workflow.c694484a.svg";